export default "__VITE_ASSET__EGMAK3TN__"